import { VelocityClient } from '@velocity-exchange/sdk';
import { useCallback } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

export const useSubscribeVelocityClient = () => {
	const setVelocityStore = useVelocityStore((s) => s.set);

	const subscribeToVelocityClientData = useCallback(
		async (velocityClient: VelocityClient) => {
			try {
				const subscriptionResult = await velocityClient.subscribe();

				if (!subscriptionResult) {
					velocityClient.unsubscribe();
				}

				setVelocityStore((s) => {
					s.velocityClient.isSubscribed = subscriptionResult;
				});

				return subscriptionResult;
			} catch (error) {
				console.error('Error subscribing to drift client data:', error);
				velocityClient.unsubscribe();
				return false;
			}
		},
		[setVelocityStore]
	);

	return { subscribeToVelocityClientData };
};
